module.exports = __webpack_public_path__ + "img/curso-redes-sociales.6847db78.png";